import React, {useEffect, Fragment, useRef} from 'react';
import {connect} from "react-redux";
//import GLBViewer from "./GLBViewer";
import LightIntensitySlider from "./workspaceComponents/LightIntensitySlider";
import LightingSwitch from "./workspaceComponents/LightingSwitch";
import SqftStore from "../../canvas/store/sqftStore";
import SeparateModelGLBViewer from "./glbViewer/SeparateModelGLBViewer";
import ExportButton from "./workspaceComponents/ExportButton";
import config from "../../canvas/store/sqftConfig";
import sqftConfig from "../../canvas/store/sqftConfig";
import {SQFT_AR3D_GLB_VIEWER} from "../../../constants";
import SingleModelGLBViewer from "./glbViewer/SingleModelGLBViewer";
import ScreenshotButton from "./workspaceComponents/ScreenshotButton";
//import SeparateModelGLBViewerV2 from "./glbViewer/SeparateModelGLBViewerV2";
//import GLBViewerModels from "./GLBViewerModels";

const ShapesThreeJsViewer = (props) => {
  const {cabinetsGlb, isMobile} = props;
  const canvasRef = useRef(null); // Changed to useRef for consistency
  const viewGLRef = useRef(null); // Use a ref to persist the GLBViewer instance
  const lightIntensity = 20;
  const minLightningValue = 0;
  const maxLightningValue = 140;

  useEffect(() => {
    if (cabinetsGlb && canvasRef.current && !viewGLRef.current) {
      let viewGL;
      switch (sqftConfig.threeD.glbViewer) {
        case SQFT_AR3D_GLB_VIEWER.singleModel:
          //this viewer will load models using Vlad's api:
          viewGL = new SingleModelGLBViewer(canvasRef.current, cabinetsGlb, lightIntensity, isMobile);
          break;
        case SQFT_AR3D_GLB_VIEWER.separateModels:
        default:
          //this viewer will load models separately (see also setCabinetGLBFromCabinetsSet):
          viewGL = new SeparateModelGLBViewer(canvasRef.current, cabinetsGlb, lightIntensity, isMobile);
          //viewGL = new SeparateModelGLBViewerV2(canvasRef.current, cabinetsGlb, lightIntensity, isMobile);
      }

      viewGLRef.current = viewGL;
      SqftStore.viewGL = viewGL;

      // ******************* EVENT LISTENERS ******************* //
      // const onMouseMove = (event) => {
      //   viewGL.onMouseMove(event);
      // }
      // const onMouseDown = (event) => {
      //   viewGL.onMouseDown(event);
      // }
      // const onMouseUp = (event) => {
      //   viewGL.onMouseUp(event);
      // }
      // const onWheel = (event) => {
      //   viewGL.onWheel(event);
      // }
      const handleResize = () => {
        viewGL.onWindowResize(window.innerWidth, window.innerHeight);
      };

      // ******************* INIT LISTENERS *******************
      // canvas.addEventListener('mousemove', onMouseMove);
      // canvas.addEventListener('mousedown', onMouseDown);
      // canvas.addEventListener('mouseup', onMouseUp);
      // canvas.addEventListener('wheel', onWheel);
      window.addEventListener('resize', handleResize);
      handleResize()

      return () => {
        // Stop animation
        viewGL.stop();
        // Dispose resources
        viewGL.dispose();
        viewGLRef.current = null;
        SqftStore.viewGL = null;

        // Remove any event listeners
        // canvas.removeEventListener('mousemove', onMouseMove);
        // canvas.removeEventListener('mousedown', onMouseDown);
        // canvas.removeEventListener('mouseup', onMouseUp);
        // canvas.removeEventListener('wheel', onWheel);
        window.removeEventListener('resize', handleResize);
        SqftStore.viewGL = null;
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canvasRef, cabinetsGlb])

  return (
    <Fragment>
      <div className={"threeDWorkspace-tools"}>
        { config.isDevMode() ? <LightIntensitySlider
            intensityValue={lightIntensity}
            minValue={minLightningValue}
            maxValue={maxLightningValue} />
          : "" }
        { config.isDevMode() ? <ExportButton/> : "" }
        { config.isDevMode() ? <LightingSwitch viewGLRef={viewGLRef} /> : "" }
        <ScreenshotButton />
      </div>
      <canvas className="threeDWorkspace-canvas" ref={canvasRef} />
    </Fragment>
  );
}

const mapStateToProps = (store) => ({
  cabinetsGlb: store.sqftState.cabinetsGlb,
  isMobile: store.serverState.isMobile,
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(ShapesThreeJsViewer);
